<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright-t"><a id="pIV"></a>Copyright © 2015 Eve MacDonald</p>
<p class="linespace"></p>
<p class="copyright">All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.</p>
<p class="linespace"></p>
<p class="copyright">For information about this and other Yale University Press publications, please contact:</p>
<p class="linespace"></p>
<p class="copyright">U.S. Office: <a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a>   <a href="http://www.yalebooks.com" target="_blank">www.yalebooks.com</a></p>
<p class="copyright">Europe Office: <a href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a>   <a href="http://www.yalebooks.co.uk" target="_blank">www.yalebooks.co.uk</a></p>
<p class="linespace"></p>
<p class="copyright">Typeset in Adobe Garamond Pro by IDSUK (DataConnection) Ltd</p>
<p class="copyright">Printed in Great Britain by Gomer Press Ltd, Llandysul, Ceredigion, Wales</p>
<p class="linespace"></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace"></p>
<p class="copyright">MacDonald, Eve.</p>
<p class="copyright-1">Hannibal : a Hellenistic life/Eve MacDonald.</p>
<p class="copyright-2">pages cm</p>
<p class="copyright-1">Includes bibliographical references and index.</p>
<p class="copyright-1">ISBN 978-0-300-15204-3 (cloth : alkaline paper)</p>
<p class="copyright-1">1. Hannibal, 247 B.C.–182 B.C. 2. Hannibal, 247 B.C.–182 B.C.—Influence.   3. Hannibal, 247 B.C.–182 B.C.—Military leadership.  4. Generals—Tunisia—Carthage (Extinct city)—Biography.  5. Punic War, 2nd, 218–201 B.C.  6. Rome—History—Republic, 265-30 B.C.  7. Carthage (Extinct city)—History.  I. Title.</p>
<p class="copyright-1">DG249.M33 2015</p>
<p class="copyright-1">937′.04092—dc23</p>
<p class="copyright-1">[B]</p>
<p class="copyright-r">2014035399</p>
<p class="linespace"></p>
<p class="copyright">A catalogue record for this book is available from the British Library.</p>
<p class="linespace"></p>
<p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?390df912